import { emotionTheme } from '@styles/theme'
import { findAccountConfig } from '@pages/ConsolidatedEntry/constants/accountsConfig'

import type { AccountIconKey } from '@pages/ConsolidatedEntry/constants/accountsConfig'

// Frame de fundo do ícone de cada Conta — exclusivo do card "Inserir Valores" (a tabela não usa frame)
const ACCOUNT_BADGE_BACKGROUND_MAP: Record<AccountIconKey, string> = {
  invoicing: '#C3E3E1',
  consumption: '#FDE8D1',
  people: '#FDE2E2',
  depreciation: '#F5E2DA',
  otherExpenses: '#F7E0E0',
  bonus: '#C2F0D7'
}

export const getAccountBadgeBackground = (accountName: string) => {
  const config = findAccountConfig(accountName)

  return config ? ACCOUNT_BADGE_BACKGROUND_MAP[config.key] : emotionTheme.colors.gray[200]
}
